export const colorTheme = {
    // 500 will always be the base colour, with 50 being the lightest shade,
    // and 900 being the darkest tone.
    // You can access individual colours in bgColor, color, etc.. with "primary.500"

    // Anything that accepts a "colorScheme" like Buttons (theres a bunch of components
    // that support it in Chakra), you can use "primary" to get the component to
    // decide which colours it needs to use to make itself look good.
    // Try it with a button!

    // These were created using a monochromatic colour scale generator
    // ie. https://hihayk.github.io/scale/#4/5/50/80/0/0/20/14/E84500/232/69/0/white
    primary: {
        900: '#803000',
        800: '#9F3D00',
        700: '#BF4A00',
        600: '#DF5700',
        500: '#FF6400',
        400: '#FF7C29',
        300: '#FF9452',
        200: '#FFAD7A',
        100: '#FFC6A3',
        50: '#FFDFCC',
        25: '#FFF7F2',
    },
    secondary: {
        900: '#270060',
        800: '#310076',
        700: '#3C008C',
        600: '#4600A0',
        500: '#5000B4',
        400: '#6C29C3',
        300: '#8852D1',
        200: '#A37ADE',
        100: '#BFA3E9',
        50: '#DCCCF4',
        25: '#F6F2FC',
    },
    black: {
        900: '#000',
        800: '#000',
        700: '#000',
        600: '#000',
        500: '#000',
        400: '#222222',
        300: '#444444',
        200: '#666666',
        100: '#888888',
        50: '#AAAAAA',
        25: '#CCCCCC',
    },
    white: '#FFF',
    charcoal: {
        900: '#181818',
        800: '#252525',
        700: '#313131',
        600: '#3E3E3E',
        500: '#4A4A4A',
        400: '#676767',
        300: '#838383',
        200: '#A0A0A0',
        100: '#BDBDBD',
        50: '#D9D9D9',
        25: '#F5F5F5',

    },
    muted: {
        900: '#37404C',
        800: '#45505F',
        700: '#546072',
        600: '#627084',
        500: '#718096',
        400: '#8794A7',
        300: '#9DA8B9',
        200: '#B4BDCA',
        100: '#CBD1DA',
        50: '#E2E6EB',
        25: '#F8F9FA',
    },
    danger: {
        900: '#781919',
        800: '#952121',
        700: '#B02A2A',
        600: '#CB3434',
        500: '#E53E3E',
        400: '#EC5A5A',
        300: '#F27777',
        200: '#F79595',
        100: '#FAB5B5',
        50: '#FDD5D5',
        25: '#FFF5F5',
    },
    warning: {
        900: '#715111',
        800: '#8B6517',
        700: '#A5781E',
        600: '#BE8B26',
        500: '#D69E2E',
        400: '#DFAF4D',
        300: '#E8BF6C',
        200: '#EFCE8D',
        100: '#F5DEAF',
        50: '#FEFAF4',
        25: '#FEFAF4',
    },
    info: {
        900: '#13416D',
        800: '#1A5186',
        700: '#21629F',
        600: '#2972B7',
        500: '#3182CE',
        400: '#4F96D9',
        300: '#6FAAE2',
        200: '#8FBEEA',
        100: '#B0D2F2',
        50: '#D3E6F8',
        25: '#F4F9FD',
    },
    success: {
        900: '#185434',
        800: '#206841',
        700: '#277C4F',
        600: '#2F8F5C',
        500: '#38A169',
        400: '#56B281',
        300: '#75C299',
        200: '#94D1B1',
        100: '#B4E0C9',
        50: '#D5EEE1',
        25: '#F5FBF8',
    },
    orange: {
        900: '#753409',
        800: '#90420E',
        700: '#AB4F13',
        600: '#C45D19',
        500: '#DD6B20',
        400: '#E68241',
        300: '#ED9962',
        200: '#F3B185',
        100: '#F8C9A9',
        50: '#FCE1CF',
        25: '#FEF7F3',
    },
    teal: {
        900: '#154F4E',
        800: '#1B6260',
        700: '#227472',
        600: '#298684',
        500: '#319795',
        400: '#50A9A8',
        300: '#70BBBA',
        200: '#91CCCB',
        100: '#B2DDDC',
        50: '#D4ECEC',
        25: '#F4FAFA',
    },
    cyan: {
        900: '#006074',
        800: '#00768E',
        700: '#008CA8',
        600: '#00A1C0',
        500: '#00B5D8',
        400: '#29C3E2',
        300: '#52D1EA',
        200: '#7ADDF2',
        100: '#A3E9F7',
        50: '#CCF3FC',
        25: '#F2FCFE',
    },
    purple: {
        900: '#3E296F',
        800: '#4F3489',
        700: '#5F40A3',
        600: '#6F4DBC',
        500: '#805AD5',
        400: '#9472DE',
        300: '#A78CE6',
        200: '#BCA5ED',
        100: '#D0C0F3',
        50: '#E5DCF9',
        25: '#F8F6FE',
    },
    pink: {
        900: '#701A46',
        800: '#8A2358',
        700: '#A42B69',
        600: '#BD357B',
        500: '#D53F8C',
        400: '#DE5B9F',
        300: '#E778B1',
        200: '#EE97C3',
        100: '#F4B6D6',
        50: '#FAD6E8',
        25: '#FEF5F9',
    },
};
